angular.module('stack.common.api.stackApi', [
  'stack.common.api.ApiController'
])

/**
 * The Api directive renders out a api
 *
 * @class Api
 * @constructor
 * @api stack.common.api.stackApi
 * @example
 *    <stack-api>
 *    </stack-api>
 */
.directive('stackApi', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {},
      controller: 'ApiController',
      templateUrl: 'js/src/stack/common/api/api.html'
    };
  }
]);
